export enum LocationSectionTab {
  CHART = 'chart',
  TABLE = 'table',
}
